// We use this to fight 524's from Cloudflare, which seem to be happening somewhat frequently
// nowadays. Unsure why.
/**
 * @param {string} url
 * @param {any} params
 */
const retryFetch = (url, params) =>
  fetch(url, params)
    .then((response) => {
      // A 401 means the login session is gone. Notify the app so it can
      // refresh its auth state instead of trusting the stale UI.
      if (response.status === 401) {
        window.dispatchEvent(new CustomEvent("api-unauthorized"));
      }
      return response;
    })
    .catch((err) => {
    console.log(`Caught error on fetch of "${url}": ${err}, retrying after 1s`);
    return new Promise(resolve => {
      // missing reject here, cause we don't actually want to throw exceptions
      setTimeout(() => {
        retryFetch(url, params).then(resolve);
      }, 1000);
    });
  });

export default retryFetch;
